import { filetypemime } from 'magic-bytes.js';

export function isObjectUrl(value?: string): boolean {
  return !!(value && value.trim() !== '' && value.startsWith('blob:'));
}

export async function getFileFromObjectUrl(str: string): Promise<File | undefined> {
  if (!str.startsWith('blob:')) {
    return;
  }

  let blob: Blob;
  try {
    const response = await fetch(str);

    if (!response.ok) {
      return;
    }

    blob = await response.blob();
  } catch (error) {
    return;
  }

  if (blob.size === 0 || !blob.type) {
    return;
  }

  return new File([blob], 'image', { type: blob.type });
}

export async function getFileMimeType(file: Blob): Promise<string> {
  const bytes = await readAsByteArray(file);
  return filetypemime(bytes)?.[0];
}

async function readAsByteArray(file: Blob): Promise<Uint8Array> {
  return new Promise<Uint8Array>((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onloadend = f => {
      if (f.target !== null && f.target.result !== null && f.target.result instanceof ArrayBuffer) {
        return resolve(new Uint8Array(f.target.result));
      }
      return reject(new Error('failed to read file'));
    };
    fileReader.onerror = reject;
    fileReader.readAsArrayBuffer(file);
  });
}
